export enum SupportedLanguages {
  EN = 'EN',
  DE = 'DE',
}

export const SUPPORTED_LANGUAGES: SupportedLanguages[] = Object.values(SupportedLanguages);
export const DEFAULT_LANGUAGE = SupportedLanguages.EN;

export const localeDateFormats = {
  [SupportedLanguages.EN]: 'MM/DD/YYYY',
  [SupportedLanguages.DE]: 'DD.MM.YYYY',
};

export const localeDateWithTimeFormats = {
  [SupportedLanguages.EN]: 'MM/DD/YYYY hh:mmA',
  [SupportedLanguages.DE]: 'DD.MM.YYYY HH:mm',
};

export const localeTimeFormats = {
  [SupportedLanguages.EN]: 'hh:mmA',
  [SupportedLanguages.DE]: 'HH:mm',
};

export const localeAdvancedDateFormats = {
  [SupportedLanguages.EN]: 'MM/DD/YYYY',
  [SupportedLanguages.DE]: 'DD.MM.YYYY',
};

export const localeAdvancedTimeFormats = {
  [SupportedLanguages.EN]: 'hh:mmA',
  [SupportedLanguages.DE]: 'HH:mm [Uhr]',
};

export const localeAdvancedDateTimeFormats = {
  [SupportedLanguages.EN]: 'MM/DD/YYYY hh:mmA',
  [SupportedLanguages.DE]: 'DD.MM.YYYY, HH:mm [Uhr]',
};
